import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment';

/**
 * Calculates the time ago upto a day otherwise returns the actual date
 *
 * Example {{ '2021-01-25T20:57:07' | agTime }}
 * @param value The value to calculate from
 * @author Brian Opiyo
 */

@Pipe({name: 'agTime'})

export class AgTimeAgoPipe implements PipeTransform {

    transform(value: any, ...args: any[]) {
        if (!value) {
            return null;
        }
        const date = moment.parseZone(value).local();

        if (args.includes('ago')) {
            return date.fromNow();
        } else if (args.includes('time-and-ago')) {
            return date.format('YYYY-MM-DD HH:mm:ssZ') + ' (' + date.fromNow() + ') ';
        } else if (args.includes('date')) {
            return date.format('YYYY-MM-DD');
        }

        // Example output: '2021-07-29 14:07:59-06:00'
        return date.format('YYYY-MM-DD HH:mm:ssZ');
    }
}
